import { IMSTokenParams, getWithIDToken } from "@utils/http/MSAuthAPI";


/**
 * Matches the backend CallRecord Pydantic model from handlers/aircall.py.
 * All Optional fields in the backend are represented as `| null`.
 */
export interface IAircallCall {
    call_uuid: string;
    aircall_id: string | null;
    direction: string | null;
    in_call_duration: number | null;
    duration_seconds: number | null;
    from_number: string | null;
    to_number: string | null;
    number_id: string | null;
    number_name: string | null;
    user_full_name: string | null;
    user_email: string | null;
    created_time: string | null;
    answered_time: string | null;
    ended_time: string | null;
    caller_country: string | null;
    call_status: string | null;
    hangup_cause: string | null;
    missed_reason: string | null;
    was_answered: string | null;
    number_was_closed: string | null;
    reached_voicemail_time: string | null;
    voicemail_recording_duration: number | null;
    has_recording: boolean | null;
    tags: string | null;
    rep_notes: string | null;
    zoho_contact_id: string | null;
}


interface IAircallService {
    getCalls(zohoContactId: string, IDTokenParams: IMSTokenParams): Promise<IAircallCall[]>;
    getCallAudioUrl(callUuid: string, IDTokenParams: IMSTokenParams): Promise<string>;
}

export const AircallService: IAircallService = {
    async getCalls(zohoContactId: string, IDTokenParams: IMSTokenParams): Promise<IAircallCall[]> {
        const resp = await getWithIDToken(
            `/v1/calls`,
            IDTokenParams,
            { zoho_contact_id: zohoContactId },
        );
        if (!resp.data?.calls) {
            throw new Error('Unexpected response format from calls endpoint');
        }
        return resp.data.calls;
    },

    async getCallAudioUrl(callUuid: string, IDTokenParams: IMSTokenParams): Promise<string> {
        const resp = await getWithIDToken(
            `/v1/calls/${callUuid}/audio`,
            IDTokenParams,
        );
        if (!resp.data?.url) {
            throw new Error('Unexpected response format from audio endpoint');
        }
        return resp.data.url;
    },
};
